<div class="modal-body">
  Internal Server Error
</div>
<div class="modal-footer">
  <button class="btn btn-md btn-primary btn-close btn-santander" (click)="onCloseClicked()">Close</button>
</div>
